import datapoints from '../datapoints';
import disableInboxRuleService from '../services/disableInboxRuleService';
import enableInboxRuleService from '../services/enableInboxRuleService';
import store from '../store/store';
import { logUsage } from 'owa-analytics';
import { action, select } from 'satcheljs/lib/legacy';
import InboxRuleRetryDialog from '../components/InboxRuleRetryDialog';
/**
 * Enables / disables the given rule
 * @param inboxRuleId the inbox rule id
 * @param shouldBeEnabled whether the inbox rule should be enabled
 */
export default select({
    optionState: function () { return store.inboxRulesListState; },
})(action('enableDisableInboxRule', datapoints.enableDisableInboxRuleDatapoint)(function enableDisableInboxRule(inboxRuleId, shouldBeEnabled, force, alwaysDeleteOutlookRulesBlob, state) {
    var optionState = state.optionState;
    var inboxRule = optionState.inboxRules.get(inboxRuleId);
    setEnableDisableInboxRuleState(shouldBeEnabled, inboxRule);
    var enableDisableInboxRulePromise;
    if (inboxRule.Enabled) {
        enableDisableInboxRulePromise = enableInboxRuleService(inboxRule, force, alwaysDeleteOutlookRulesBlob);
    }
    else {
        enableDisableInboxRulePromise = disableInboxRuleService(inboxRule, force, alwaysDeleteOutlookRulesBlob);
    }
    // TODO: Proper error handling / success notification
    // Task 20143: Full error handling / success notification support
    return enableDisableInboxRulePromise
        .then(function (response) {
        if (!response.WasSuccessful) {
            setEnableDisableInboxRuleState(!shouldBeEnabled, inboxRule);
            if (response.UserPrompt) {
                var dialog = new InboxRuleRetryDialog(response.UserPrompt, function (isChecked) {
                    return enableDisableInboxRule(inboxRuleId, !inboxRule.Enabled, true /*force*/, isChecked /*alwaysDeleteOutlookRulesBlob*/, { optionState: store.inboxRulesListState });
                }, function () { });
                dialog.show();
            }
            logUsage(datapoints.inboxRuleActionFailDatapoint.datapoint.name, [
                shouldBeEnabled ? 'EnableInboxRule' : 'DisableInboxRule',
            ]);
        }
        return Promise.resolve();
    })
        .catch(function (error) {
        logUsage(datapoints.inboxRuleActionFailDatapoint.datapoint.name, [
            shouldBeEnabled ? 'EnableInboxRule' : 'DisableInboxRule',
        ]);
        return Promise.resolve();
    });
}));
var setEnableDisableInboxRuleState = action('setEnableDisableInboxRuleState')(function setEnableDisableInboxRuleState(shouldBeEnabled, inboxRule) {
    inboxRule.Enabled = shouldBeEnabled;
});
//# sourceMappingURL=enableDisableInboxRule.js.map